import ExpanderPanel from '@rio-cloud/rio-uikit/ExpanderPanel';

import { ProductTypedFormattedMessage } from '../../common/product/ProductTypedFormattedMessage';
import { ProductIcon } from '../../common/productImages/ProductIcon';
import type { TermedLevel } from '../../common/termedLevel/types';
import { mapResourceTypeToProductType } from '../contracts/mapResourceTypeToProductType';
import { BookingOverviewContractTable } from './BookingOverviewContractTable';

interface Props {
    contracts: TermedLevel[];
}

function groupContractsByProduct(contracts: TermedLevel[]): TermedLevel[][] {
    return Array.from(
        contracts
            .reduce((groups, contract) => {
                const productContracts = groups.get(contract.productId) ?? [];
                productContracts.push(contract);
                groups.set(contract.productId, productContracts);
                return groups;
            }, new Map<string, TermedLevel[]>())
            .values()
    );
}

function ProductPanelHeader({ contracts }: Props) {
    const { productId, productName, resourceType } = contracts[0];
    const productType = mapResourceTypeToProductType(resourceType);

    return (
        <div className='display-flex align-items-center'>
            <ProductIcon productId={productId} className='width-30 height-30 margin-right-10' />
            <span className='text-size-h4 text-bold'>{productName}</span>
            <span className='text-color-dark margin-left-5'>
                <ProductTypedFormattedMessage
                    productType={productType}
                    assetBasedId='intl-msg:marketplace.bookings.overview.product.asset.count'
                    userBasedId='intl-msg:marketplace.bookings.overview.product.user.count'
                    values={{ count: contracts.length }}
                />
            </span>
        </div>
    );
}

export function BookingOverviewProductList({ contracts }: Props) {
    const groupedContracts = groupContractsByProduct(contracts);

    return (
        <div className='display-flex flex-column gap-10'>
            {groupedContracts.map((productContracts, index) => {
                const productId = productContracts[0].productId;
                const productType = mapResourceTypeToProductType(productContracts[0].resourceType);

                return (
                    <ExpanderPanel
                        key={productId}
                        title={<ProductPanelHeader contracts={productContracts} />}
                        bsStyle='default'
                        bodyClassName='padding-0'
                        className='shadow-default'
                        open={index === 0}
                    >
                        <BookingOverviewContractTable contracts={productContracts} productType={productType} />
                    </ExpanderPanel>
                );
            })}
        </div>
    );
}
